import React from "react";
import { Carousel } from "antd";

const EventsSlider = ({ images }) => (
  <Carousel autoplay>
    {images
      .filter((image) => image)
      .map((image, index) => {
        return image;
      })
      .map((image, index) => {
        return (
          <div key={index} className="carousal-img bg-black">
            <img src={image} alt="hag" />
          </div>
        );
      })}
  </Carousel>
);
export default EventsSlider;
